"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletHalo = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const settings_1 = require("./settings");
const squiggly_1 = require("./squiggly");
const SQUIGGLY_LOBES = 12;
const SQUIGGLY_AMP = 1;
const dashFor = (style, strokeWidth) => {
    if (style === 'dashed')
        return { dash: `${(strokeWidth * 2.5).toFixed(2)} ${(strokeWidth * 1.8).toFixed(2)}`, cap: 'butt' };
    if (style === 'dotted')
        return { dash: `0 ${(strokeWidth * 2.2).toFixed(2)}`, cap: 'round' };
    return { cap: 'butt' };
};
/**
 * Decorative halo drawn around the bullet, just outside its outline.
 */
const BulletHalo = ({ style, color, strokeWidth }) => {
    if (style === 'none' || strokeWidth <= 0)
        return null;
    const padding = Math.max(SQUIGGLY_AMP + strokeWidth, strokeWidth * 2);
    const outerSize = settings_1.INDICATOR_SIZE + settings_1.HALO_OFFSET * 2 + padding * 2;
    const center = outerSize / 2;
    const meanRadius = settings_1.INDICATOR_SIZE / 2 + settings_1.HALO_OFFSET;
    const path = style === 'squiggly'
        ? (0, squiggly_1.squigglyCirclePath)(center, meanRadius, SQUIGGLY_LOBES, SQUIGGLY_AMP)
        : (0, squiggly_1.plainCirclePath)(center, meanRadius);
    const { dash, cap } = dashFor(style, strokeWidth);
    return (React.createElement("svg", { width: outerSize, height: outerSize, viewBox: `0 0 ${outerSize} ${outerSize}`, "aria-hidden": "true", style: {
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            overflow: 'visible',
        } },
        React.createElement("path", { d: path, fill: "none", stroke: color, strokeWidth: strokeWidth, strokeDasharray: dash, strokeLinecap: cap })));
};
exports.BulletHalo = BulletHalo;
